import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Home from "./Home";
import Yomumo from "./Yomumo";
import Tokutei from "./Tokutei";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { BrowserRouter, Routes, Route } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="yomumo" element={<Yomumo />} />
        <Route path="tokutei/" element={<Tokutei />} />
        <Route
          path="*"
          element={
            <main style={{ padding: "1rem" }}>
              ページが存在しません。
              <a href="https://eteq.co.jp/">株式会社ETeqのホームページ</a>
              へ移動します。
            </main>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
